export default __webpack_public_path__ + "static/page.dark-0bd5d760afc780adeba82bd64d95b24914bd55b2ab07137c22f23af28b4c4afe.png";